import {formatNumber} from '@shared/lib/utils/number';

export const numGroup = (value: number, options: {fractionDigits?: number} = {}) => {
    if (!Number.isFinite(value)) return '0';
    if (options.fractionDigits === 0)
        return new Intl.NumberFormat('ru-RU').format(Math.round(value));
    return formatNumber(value);
};

export const getRiskColor = (value?: string) => {
    switch (value) {
        case 'YELLOW':
            return '#F3C10E';
        case 'GREEN':
            return '#52CB50';
        case 'RED':
            return '#FF573F';
        default:
            return '#939AA4';
    }
};

export const getRiskTextColor = (value?: string) => {
    switch (value) {
        case 'YELLOW':
            return '#987607';
        case 'GREEN':
            return '#146F29';
        case 'RED':
            return '#AF0808';
        default:
            return '#59606A';
    }
};

export const getRiskBackgroundColor = (value?: string) => {
    switch (value) {
        case 'YELLOW':
            return '#FFF9E7';
        case 'GREEN':
            return '#F2FFEE';
        case 'RED':
            return '#FFE8E8';
        default:
            return '#FFFFFF';
    }
};
